module.exports = __webpack_public_path__ + "application/templates/default/inner/publications/partials/submenu/submenu.template.html";